import { Box } from "@mui/material";
import { styled } from "@mui/system";

export const PopperActionBannerContainer = styled(Box)(() => ({
  backgroundColor: "#fff",
  padding: "8px 16px",
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  flexShrink: 0,
  borderTopLeftRadius: "8px",
  borderTopRightRadius: "8px",
  boxShadow:
    "0px 1px 8px 0px #0000001F, 0px 3px 4px 0px #00000024, 0px 3px 3px -2px #00000033",
}));
